import React, {ChangeEvent, useState} from 'react';

import {Modal} from './Modal';
import {DataTableColumn} from '../types';

type CustomizeColumnsModalProps = {
    availableColumns: SearchAvailableColumn[];
    selectedColumns: string[];
    setShow: (show: boolean) => void;
    onSave: (columns: DataTableColumn[]) => void;
};

export type SearchAvailableColumn = {
    label: string;
    adminLabel: string;
    sectionLabel: string;
    note?: string;
    noExport?: boolean;
};

export const CustomizeColumnsModal: React.FunctionComponent<CustomizeColumnsModalProps> = ({
                                                                                               availableColumns = [],
                                                                                               selectedColumns = [],
                                                                                               setShow,
                                                                                               onSave,
                                                                                           }): JSX.Element => {
    const [customizeColumnsFilterText, setCustomizeColumnsFilterText] = useState<string>('');
    const [customizeColumnsFormState, setCustomizeColumnsFormState] = useState<string[]>(selectedColumns);

    const searchFilterContainerClasses = [
        'input-group',
        'search-filter-input-container',
        customizeColumnsFilterText && 'filtered'
    ]
        .filter(Boolean)
        .join(' ');

    return (
        <Modal>
            <div className="modal-header">
                <h5 className="modal-title">Customize Columns</h5>
                <button type="button"
                        className="close"
                        aria-label="Close"
                        tabIndex={-1}
                        onClick={() => {
                            setShow && setShow(false);
                        }}
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div className="modal-body">
                <div className="container">
                    <div className="row mb-2">
                        <div className="col">
                            <div className={searchFilterContainerClasses}>
                                <input type="text"
                                       className="form-control form-control-lg"
                                       placeholder="Enter text to filter fields...."
                                       value={customizeColumnsFilterText}
                                       onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                           setCustomizeColumnsFilterText(e.target.value);
                                       }}
                                />
                                {customizeColumnsFilterText &&
                                <div className="input-group-append">
                                            <span className="input-group-text"
                                                  id="basic-addon2"
                                                  style={{
                                                      borderLeft: 'none',
                                                      background: 'transparent'
                                                  }}
                                            >
                                                <i className="fas fa-times"
                                                   onClick={() => {
                                                       setCustomizeColumnsFilterText('')
                                                   }}
                                                />
                                            </span>
                                </div>
                                }
                            </div>
                            <div className="text-right mb-3">
                                <button type="button"
                                        className="btn btn-link"
                                        onClick={() => {
                                            setCustomizeColumnsFormState(Object.keys(availableColumns));
                                        }}
                                    >Select All Columns</button>
                                <button type="button"
                                        className="btn btn-link"
                                        onClick={() => {
                                            setCustomizeColumnsFormState([]);
                                        }}
                                >Clear All Columns</button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {Object.keys(availableColumns)
                            .filter((columnKey: string) => !customizeColumnsFilterText || availableColumns[columnKey as any].label.match(new RegExp(customizeColumnsFilterText, 'i')))
                            .map((columnKey: string, index: number) => (
                                <div key={index} className="col-6">
                                    <div className="form-check">
                                        <input className="form-check-input"
                                               type="checkbox"
                                               value={columnKey}
                                               id={`column-${columnKey}`}
                                               checked={customizeColumnsFormState.find((col: string) => col === columnKey) !== undefined}
                                               onChange={(e) => {
                                                   if (e.target.checked) {
                                                       setCustomizeColumnsFormState([
                                                           ...customizeColumnsFormState,
                                                           columnKey
                                                       ]);
                                                   } else {
                                                       const idx = customizeColumnsFormState.findIndex((col: string) => col === columnKey);
                                                       setCustomizeColumnsFormState([
                                                           ...customizeColumnsFormState.slice(0, idx),
                                                           ...customizeColumnsFormState.slice(idx + 1)
                                                       ]);
                                                   }
                                               }}
                                        />
                                        <label className={[
                                            'form-check-label',
                                            ['created_by_on_date', 'flow_entry_description'].includes(columnKey) && 'non-exportable-column',
                                        ].filter(Boolean).join(' ')}
                                               htmlFor={`column-${columnKey}`}>
                                            {availableColumns[columnKey as any].label}
                                            {availableColumns[columnKey as any]?.note && <small>({availableColumns[columnKey as any]?.note})</small>}
                                        </label>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
                <p className="mt-3 non-exportable-column"><em>These fields are not available for export</em></p>
            </div>
            <div className="modal-footer">
                <button type="button"
                        className="btn btn-primary"
                        onClick={() => {
                            setShow && setShow(false);
                            onSave(customizeColumnsFormState.map((col: string) => ({
                                prop: col,
                                ...availableColumns[col as any]
                            })));
                        }}
                >Save
                </button>
            </div>
        </Modal>
    )
};